/**
 * @fileoverview added by tsickle
 * Generated from: models/task.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/** @enum {string} */
var TaskType = {
    // Primary cleaning tasks:
    AfterBuildersClean: "after-builders-clean",
    Cleaning: "cleaning",
    DeepClean: "deep-clean",
    EndOfTenancyClean: "end-of-tenancy-clean",
    CarpetClean: "carpet-cleaning-primary-task-type",
    // Base tasks:
    Fridge: "fridge",
    Freezer: "freezer",
    IndoorWindows: "indoor",
    Ironing: "ironing",
    KeyCollection: "collect",
    KeyReturn: "return-keys",
    RemoteKeyTransfer: "remote-key-transfer",
    Laundry: "laundry",
    Oven: "oven",
    Products: "products",
    Carpet: "carpet",
    // Upholstery tasks:
    SteamCleaning: "steam-clean",
    Rug: "rug",
    Sofa: "sofa",
    Curtains: "curtains",
    Blinds: "blinds",
    Mattress: "mattress",
    // Sofa tasks:
    Sofa2Seats: "sofa-2-seats",
    Sofa3Seats: "sofa-3-seats",
    Sofa3SeatsLShaped: "sofa-3-seats-L-shaped",
    Sofa4SeatsLShaped: "sofa-4-seats-L-shaped",
    Sofa5SeatsLShaped: "sofa-5-seats-L-shaped",
    // Mattress tasks:
    MattressSingle: "mattress-single",
    MattressDouble: "mattress-double",
    MattressQueen: "mattress-queen",
    MattressKing: "mattress-king",
    // Blinds:
    BlindsRoman: "blinds-roman",
    BlindsVenetian: "blinds-venetian",
    // Trades tasks:
    TradesMaterials: "trades-materials",
    TradesSurvey: "trades-survey",
    TradesWork: "trades-work",
    // Other line items modelled as "tasks" - these are deliberately not labelled in TASK_TYPE_LABELS
    LateSkip: "late-skip",
    SkipAndPay: "skip-and-pay",
    Tip: "tip",
};
export { TaskType };
/** @enum {string} */
var PrimaryTaskType = {
    Cleaning: "cleaning",
    AfterBuildersClean: "after-builders-clean",
    DeepClean: "deep-clean",
    EndOfTenancyClean: "end-of-tenancy-clean",
    CarpetCleaning: "carpet-cleaning-primary-task-type",
};
export { PrimaryTaskType };
/** @enum {string} */
var SpecialistCleanPrimaryTaskType = {
    AfterBuildersClean: "after-builders-clean",
    DeepClean: "deep-clean",
    EndOfTenancyClean: "end-of-tenancy-clean",
    CarpetCleaning: "carpet-cleaning-primary-task-type",
};
export { SpecialistCleanPrimaryTaskType };
/**
 * Map of `TaskType` to readable description of the task, used for display purposes.
 * @type {?}
 */
export var TASK_TYPE_LABELS = new Map([
    [TaskType.AfterBuildersClean, 'After builders cleaning'],
    [TaskType.Cleaning, 'Cleaning'],
    [TaskType.DeepClean, 'Deep cleaning'],
    [TaskType.EndOfTenancyClean, 'End of tenancy cleaning'],
    [TaskType.CarpetClean, 'Carpet cleaning'],
    [TaskType.Fridge, 'Inside fridge'],
    [TaskType.Freezer, 'Inside freezer'],
    [TaskType.Ironing, 'Ironing'],
    [TaskType.IndoorWindows, 'Indoor windows'],
    [TaskType.KeyCollection, 'Spare keys collection'],
    [TaskType.KeyReturn, 'Return keys'],
    [TaskType.Laundry, 'Laundry'],
    [TaskType.Oven, 'Inside oven'],
    [TaskType.Products, 'Bring cleaning products'],
    [TaskType.SteamCleaning, 'Steam cleaning'],
    [TaskType.TradesMaterials, 'Materials (Trades)'],
    [TaskType.TradesSurvey, 'Survey (Trades)'],
    [TaskType.TradesWork, 'Work (Trades)'],
    [TaskType.SteamCleaning, 'Steam cleaning'],
    [TaskType.Carpet, 'Steam cleaning: Carpet'],
    [TaskType.Rug, 'Steam cleaning: Rug'],
    [TaskType.Sofa, 'Steam cleaning: Sofa'],
    [TaskType.Curtains, 'Steam cleaning: Curtains'],
    [TaskType.Blinds, 'Steam cleaning: Blinds'],
    [TaskType.Mattress, 'Steam cleaning: Mattress'],
    [TaskType.Sofa2Seats, 'Steam cleaning: Sofa 2 seater'],
    [TaskType.Sofa3Seats, 'Steam cleaning: Sofa 3 seater'],
    [TaskType.Sofa3SeatsLShaped, 'Steam cleaning: Sofa L shaped 3 seater'],
    [TaskType.Sofa4SeatsLShaped, 'Steam cleaning: Sofa L shaped 4 seater'],
    [TaskType.Sofa5SeatsLShaped, 'Steam cleaning: Sofa L shaped 5 seater'],
    [TaskType.MattressSingle, 'Steam cleaning: Single mattress'],
    [TaskType.MattressDouble, 'Steam cleaning: Double mattress'],
    [TaskType.MattressQueen, 'Steam cleaning: Queen mattress'],
    [TaskType.MattressKing, 'Steam cleaning: King mattress'],
    [TaskType.BlindsRoman, 'Steam cleaning: Roman blinds'],
    [TaskType.BlindsVenetian, 'Steam cleaning: Venetian blinds']
]);
/**
 * Icon names for each task type.
 * There should be an icon for every task type defined in `TASK_TYPES`.
 * https://sad-meninsky-167725.netlify.app/?path=/docs/web-components-icon--sizing#icon
 * @type {?}
 */
export var TASK_TYPE_ICONS = new Map([
    [TaskType.AfterBuildersClean, 'house'],
    [TaskType.Cleaning, 'mop-bucket'],
    [TaskType.DeepClean, 'sponge'],
    [TaskType.EndOfTenancyClean, 'sofa'],
    [TaskType.CarpetClean, 'carpet-rolled'],
    [TaskType.Fridge, 'fridge'],
    [TaskType.Freezer, 'freezer'],
    [TaskType.Ironing, 'iron'],
    [TaskType.IndoorWindows, 'window'],
    [TaskType.KeyCollection, 'key'],
    [TaskType.KeyReturn, 'key'],
    [TaskType.Laundry, 'washing-machine'],
    [TaskType.Oven, 'oven'],
    [TaskType.Products, 'spray-bottle'],
    [TaskType.SteamCleaning, 'steamer'],
    [TaskType.TradesMaterials, 'wrench'],
    [TaskType.TradesSurvey, 'wrench'],
    [TaskType.TradesWork, 'wrench']
]);
/**
 * A list of tasks that take a variable number of hours.
 * @type {?}
 */
var HOURLY_VARIABLE_TASKS = [
    TaskType.Cleaning,
    TaskType.Fridge,
    TaskType.Ironing,
    TaskType.IndoorWindows,
    TaskType.Laundry,
    TaskType.Oven
];
/** @type {?} */
var ACTIONABLE_TASKS = HOURLY_VARIABLE_TASKS.concat([
    TaskType.Products,
    TaskType.KeyCollection,
    TaskType.KeyReturn,
    TaskType.DeepClean,
    TaskType.RemoteKeyTransfer
]);
/**
 * Base model for a visit task, containing all relevant fields returned by the API.
 * @record
 */
function BaseTaskModel() { }
if (false) {
    /** @type {?} */
    BaseTaskModel.prototype.details;
    /** @type {?} */
    BaseTaskModel.prototype.hours;
    /** @type {?} */
    BaseTaskModel.prototype.price;
    /** @type {?} */
    BaseTaskModel.prototype.type;
    /** @type {?|undefined} */
    BaseTaskModel.prototype.icon;
    /** @type {?|undefined} */
    BaseTaskModel.prototype.displayLabel;
}
/**
 * Helper properties for the `Task` model.
 * @record
 */
function TaskModelMixin() { }
if (false) {
    /** @type {?} */
    TaskModelMixin.prototype.typeIcon;
    /** @type {?} */
    TaskModelMixin.prototype.isTimed;
    /** @type {?} */
    TaskModelMixin.prototype.isFixed;
    /** @type {?} */
    TaskModelMixin.prototype.isActionable;
    /** @type {?|undefined} */
    TaskModelMixin.prototype.typeLabel;
}
/**
 * Model representing a visit task.
 * @record
 */
export function Task() { }
/** @type {?} */
export var task = model.extend((/** @type {?} */ ({
    modelName: 'task'
})));
// Implements helper properties declared in TaskModelMixin
defineModelProperties(task, {
    typeIcon: {
        get: /**
         * @return {?}
         */
        function () {
            return this.icon || TASK_TYPE_ICONS.get(this.type);
        }
    },
    isActionable: {
        get: /**
         * @return {?}
         */
        function () {
            return ACTIONABLE_TASKS.includes(this.type);
        }
    },
    isTimed: {
        get: /**
         * @return {?}
         */
        function () {
            return HOURLY_VARIABLE_TASKS.includes(this.type);
        }
    },
    isFixed: {
        get: /**
         * @return {?}
         */
        function () {
            return !this.isTimed;
        }
    },
    typeLabel: {
        get: /**
         * @return {?}
         */
        function () {
            return TASK_TYPE_LABELS.get(this.type);
        }
    }
});
